export const PICKER_WIDTH = 500
export const PICKER_MIN_WIDTH = 360
export const STACK_TIME_BELOW_WIDTH = 420
export const PANEL_ESTIMATED_HEIGHT = 360
const GAP = 8
const MARGIN = 12

export type PickerPosition = {
  top: number
  left: number
  width: number
  maxHeight: number
}

export function computePickerPosition(
  anchor: Pick<DOMRect, 'top' | 'bottom' | 'left'>,
  panelHeight: number,
  viewportW: number,
  viewportH: number,
): PickerPosition {
  const width = Math.min(PICKER_WIDTH, Math.max(240, viewportW - MARGIN * 2))
  const maxHeight = Math.max(240, viewportH - MARGIN * 2)
  const height = Math.min(Math.max(panelHeight, 1), maxHeight)

  let top = anchor.bottom + GAP
  if (top + height > viewportH - MARGIN) {
    top = anchor.top - height - GAP
  }
  if (top < MARGIN) {
    top = MARGIN
  }
  if (top + height > viewportH - MARGIN) {
    top = Math.max(MARGIN, viewportH - height - MARGIN)
  }

  let left = anchor.left
  if (left + width > viewportW - MARGIN) {
    left = viewportW - width - MARGIN
  }
  if (left < MARGIN) left = MARGIN

  return { top, left, width, maxHeight }
}

export function samePickerPosition(a: PickerPosition, b: PickerPosition) {
  return a.top === b.top && a.left === b.left && a.width === b.width && a.maxHeight === b.maxHeight
}
